export default __webpack_public_path__ + "/dist/images/italian-contentimg-1.1f7f99010d1835fee81e420eab2b3e23.png";